import React, { Component } from 'react';

class WapButtomPopUp extends Component {

  // TODO: Upgrade this method
  removeModal = () => {
    if (Array.from(document.getElementsByTagName('body'))[0].classList.value === 'noscroll') {
      document.body.classList.remove('noscroll');
    }
    this.props.handleCloseModal();
  }

  render() {
    const { modalTitle, maxHeight } = this.props;
    const closeIcon = (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
          fill="#000"
        />
      </svg>
    );
    return (
      <section className="modalContainer" onClick={this.removeModal}>
        <div className="modalBody" onClick={e => e.stopPropagation()} >
          <div id="header" className="header">
            <span>{modalTitle}</span>
            <button
              style={{ transform: 'none', marginTop: '15px' }}
              onClick={this.props.handleCloseModal}
            >
              {closeIcon}
            </button>
          </div>

          <div className="content" style={{ maxHeight: `${maxHeight}px` }}>
            {this.props.children}
          </div>

          <div className="mainAction" />
        </div>
      </section>
    );
  }
}

export default WapButtomPopUp;
